module.exports = __webpack_public_path__ + "c3060c90ca7ce13bf39a5144f65a74bc.jpg";